import { useSendBlockModal } from '@/contexts/SendBlockModalContext';
import { EmailVerificationModal } from './EmailVerificationModal';
import { useApp } from '@/components/AppLayout';

export function GlobalEmailVerificationModal() {
  const {
    emailVerificationOpen,
    emailForVerification,
    closeEmailVerificationModal,
    onEmailVerificationSuccess,
  } = useSendBlockModal();
  const { refreshUser } = useApp();

  const handleSuccess = () => {
    // Refresh user data so is_email_verified is updated
    refreshUser();
    onEmailVerificationSuccess();
  };

  if (!emailForVerification) return null;

  return (
    <EmailVerificationModal
      open={emailVerificationOpen}
      onOpenChange={(open) => {
        if (!open) closeEmailVerificationModal();
      }}
      email={emailForVerification}
      onSuccess={handleSuccess}
    />
  );
}
